import axios from 'axios';

// The ZATCA service (ZatcaTest). It owns onboarding and monitoring; the RMS
// backend is not involved in either.
//
// Locally ZatcaTest runs on http://localhost:5210. In production it runs on the
// same server as the RMS backend, on its own port — and over HTTPS, because an
// HTTPS page cannot call an HTTP API. Set REACT_APP_ZATCA_API_URL to override.
export const ZATCA_API_URL = process.env.REACT_APP_ZATCA_API_URL || 'http://localhost:5210';

const zatcaApi = axios.create({
    baseURL: ZATCA_API_URL,
    headers: { 'Content-Type': 'application/json' }
});

// Names the acting user in ZatcaTest's onboarding log.
const userHeaders = (userName) => (userName ? { headers: { 'X-Zatca-User': userName } } : {});

const unitPath = (egsUnitId) => '/api/units/' + encodeURIComponent(egsUnitId) + '/onboarding';

export const getUnitOnboardingStatus = (egsUnitId) =>
    zatcaApi.get(unitPath(egsUnitId) + '/status');

export const requestComplianceCertificate = (egsUnitId, otp, userName) =>
    zatcaApi.post(unitPath(egsUnitId) + '/compliance-csid', { otp }, userHeaders(userName));

export const runComplianceCheck = (egsUnitId, kind, userName) =>
    zatcaApi.post(unitPath(egsUnitId) + '/compliance-checks?kind=' + encodeURIComponent(kind), null, userHeaders(userName));

export const requestProductionCertificate = (egsUnitId, userName) =>
    zatcaApi.post(unitPath(egsUnitId) + '/production-csid', null, userHeaders(userName));

export const getQueueSummary = (companyId) =>
    zatcaApi.get('/api/monitor/summary?companyId=' + encodeURIComponent(companyId));

export const getRejectedInvoices = (companyId) =>
    zatcaApi.get('/api/monitor/rejected?companyId=' + encodeURIComponent(companyId));

export default zatcaApi;
